import React, { useState, useEffect, useRef } from 'react';
import { Zap, Square } from 'lucide-react';

function LoadingIndicator({ isLoading, statusMessage, onCancel }) {
  const [elapsedSeconds, setElapsedSeconds] = useState(0);
  const startTimeRef = useRef(null);

  useEffect(() => {
    if (!isLoading && !onCancel) {
      setElapsedSeconds(0);
      startTimeRef.current = null;
      return;
    }

    if (!startTimeRef.current) {
      startTimeRef.current = Date.now();
    }

    const interval = setInterval(() => {
      if (startTimeRef.current) {
        setElapsedSeconds(Math.floor((Date.now() - startTimeRef.current) / 1000));
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [isLoading, onCancel]);

  if (!isLoading && !onCancel) return null;

  // Strip emoji prefixes from status messages for cleaner display
  const cleanStatus = (statusMessage || 'Processing...').replace(/^[\u{1F300}-\u{1FAFF}\u{2600}-\u{27BF}\u{FE00}-\u{FE0F}\u{1F900}-\u{1F9FF}]\s*/u, '');

  const formatElapsed = (seconds) => {
    if (seconds < 60) return `${seconds}s`;
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}m ${secs}s`;
  };

  return (
    <div className="loading-indicator">
      <div className="loading-card">
        <div className="loading-header">
          <div className="loading-title">
            <Zap size={14} className="loading-icon" />
            <span>Running</span>
          </div>
          {onCancel && (
            <button
              className="loading-cancel-btn"
              onClick={onCancel}
              title="Cancel the current operation"
              aria-label="Cancel operation"
            >
              <Square size={10} />
              Cancel
            </button>
          )}
        </div>
        <div className="loading-progress-track">
          <div className="loading-progress-bar" />
        </div>
        <div className="loading-footer">
          <div className="loading-status">
            <span className="loading-status-dot" />
            <span className="loading-status-text">{cleanStatus}</span>
          </div>
          <span className="loading-elapsed">{formatElapsed(elapsedSeconds)}</span>
        </div>
      </div>
    </div>
  );
}

export default LoadingIndicator;
